<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-2 mb-[40px]">{{ data?.name || 'Edit project details' }}</div>
  <div class="details flex-1">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [maxLength]="255"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="name"
      />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['number']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="number"
      label="number"
      />
    @if (showClient) {
      <app-text-input
        [maxLength]="255"
        [parentFormGroup]="form"
        class="w-full mb-[32px]"
        controlName="client"
        hint="Used on report headers that include a client"
        label="client"
        />
    }
    <app-date-range-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['project_start_date'] || errorMessages['project_end_date']"
      [parentFormGroup]="form"
      endDateControlName="project_end_date"
      label="project duration"
      placeholderStart="Start date"
      placeholderEnd="End date"
      startDateControlName="project_start_date"
      class="w-full mb-[20px]"
      />
    <app-number-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['project_value']"
      [parentFormGroup]="form"
      [showCurrency]="true"
      class="w-full mb-[20px]"
      controlName="project_value"
      label="project value"
      />
    <app-number-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['change_order_days']"
      [parentFormGroup]="form"
      class="w-full mb-[30px]"
      controlName="change_order_days"
      hint="Additional days added to the project duration"
      label="change order days"
      />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['description']"
      [parentFormGroup]="form"
      class="w-full mb-[40px]"
      controlName="description"
      label="description"
      />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['status']"
      [options]="statusOptions"
      [parentFormGroup]="form"
      class="w-full"
      controlName="status"
      label="Status"
      />
    <div class="location-section mt-[20px] mb-[40px]">
      @if (showLocationSection()) {
        <app-location-section
          (onDelete)="deleteLocation($event)"
          [isEditable]="true"
          [latitude]="form?.controls?.latitude?.value"
          [longitude]="form?.controls?.longitude?.value"
          class="location-section"
          />
      }
    </div>
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [add]="true"
      [isEditable]="true"
      [maxPictures]="1"
      [pictures]="mediaFiles"
      class="pictures-section mb-[40px] mt-[20px]"
      label="cover photo:"
      />
  </div>
  <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full items-center">
    <app-primary-button (handleClick)="save()" [isDisabled]="!isFormDirty" class="flex-1">Save</app-primary-button>
    <div [matMenuTriggerFor]="addMenu" class="action-button add-button">
      <mat-icon class="add" svgIcon="plus" />
    </div>
  </div>
</div>
<mat-menu #addMenu="matMenu">
  @for (option of addMenuOptions; track option) {
    <button (click)="option.handler()" mat-menu-item>
      <div class="add-menu-item flex justify-start items-center gap-[12px]">
        <mat-icon [svgIcon]="option.icon" class="menu-icon" />
        <span class="menu-label">{{ option.label }}</span>
      </div>
    </button>
  }
</mat-menu>
